module.exports = __webpack_public_path__ + "img/LUB00342.d792cdd5.svg";